"use client";

import { Heart } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DownloadFullMenu() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  return <section data-section-id="1985" id="download-full-menu" className="dark relative overflow-hidden bg-background py-24 sm:py-32">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
      background: "linear-gradient(135deg, hsla(340, 50%, 45%, 0.05) 0%, hsla(350, 40%, 94%, 0.03) 45%, hsla(240, 10%, 12%, 0.05) 100%)"
    }} />

      {}
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <Heart className="size-[22rem] text-primary opacity-[0.08]" strokeWidth={0.75} />
      </div>

      <div ref={ref} className={`relative mx-auto flex max-w-2xl flex-col items-center px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"}`}>
        

        <h2 className="font-default text-4xl font-light tracking-tight text-foreground sm:text-6xl">
          Explore Our Artistry
        </h2>

        <p className="mt-6 font-default text-xl leading-relaxed text-muted-foreground">
          Discover our complete collection of precision cuts, bespoke color transformations, and restorative treatments. Download our full service guide to plan your next salon experience.
        </p>

        <div className="mt-10 flex flex-col items-center gap-5 sm:flex-row sm:gap-8">
          <Button asChild size="lg" className="h-12 rounded-lg bg-primary px-8 text-base font-medium text-primary-foreground shadow-lg hover:bg-primary/90">
            <Link to="/BookPage">Download Guide</Link>
          </Button>

          <Link to="/ArtistryPage" className="font-default text-base text-foreground underline-offset-4 transition-colors hover:text-primary hover:underline">
            View our portfolio
          </Link>
        </div>
      </div>
    </section>;
}